<!---job list -->
<div class="dashboard_bred_crumb">
    <ul>
        <li> <a [routerLink]="['/profile/my-dashboard']" routerLinkActive="active-link">Home</a> </li>
        <li><img src="../../../../../assets/images/icons/bred_crumb_arrow.svg" alt=""></li>
        <li><a [routerLink]="['/profile/course-listing']" routerLinkActive="active-link">Course Listing</a></li>
    </ul>
</div>


<section class="dashboard_content_sec">
    <section class="master_add_sec filterSec ">
        <div style="display: flex; flex-wrap: wrap; align-items:center;justify-content: space-between;">
            <div class="job_head">
                Course Listing
            </div>
            <div class="create-job-btn">
                <button type="submit" class="btn btn-sm global-btn mat-button" (click)="handleCreateJobClick()"
                    type="submit" mat-button>
                    Create New Course
                </button>
            </div>

        </div>


        <div style="display: flex; justify-content: space-between; align-items: center; margin-top: 20px;">
            <!-- Left side: Search input -->
            <div class="search-container">
                <input type="text" class="search-input" name="search"
                    placeholder="Search by Course name, Company, Presenter" [(ngModel)]="searchTerm"
                    (ngModelChange)="onSearchChange()" />
                <img src="../../../../../../../assets/images/icons/search_grey.svg" alt="Search" class="search-icon"
                    (click)="onSearchClick()" />
            </div>

            <!-- Right side: Filter button -->
            <div class="search-box" style="margin-left: 10px;" *ngIf="loginDetails?.type === 'ADMIN' ">
                <button type="button" mat-button class="table-filter-btn" (click)="toggleFilter()"
                    style="display: flex; align-items: center;">
                    <img *ngIf="!openFilter" src="../../../../../assets/images2/Funnel.svg" alt="Filter" width="16"
                        height="16" style="margin-right: 5px;" />
                    <mat-icon *ngIf="openFilter" style="margin-right: 5px;">close</mat-icon>
                    Filter
                </button>
            </div>
        </div>

        <!-- Filter dropdown section -->
        <section *ngIf="openFilter" class="basic-filter openclose-filter-sec">
            <div class="filter-row">
                <!-- Type Filter -->
                <div>
                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Type</mat-label>
                        <input matInput placeholder="Search Type" [matAutocomplete]="typeAuto"
                            (input)="onTypeInput($event.target.value)" [(ngModel)]="filterType">
                        <mat-autocomplete #typeAuto="matAutocomplete"
                            (optionSelected)="onTypeSelected($event.option.value)">
                            <mat-option *ngFor="let type of filteredCourseTypes" [value]="type.name">
                                {{ type.name }}
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                </div>

                <!-- Company Filter -->
                <div class="dropdown-container">
                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Company</mat-label>
                        <input matInput placeholder="Search Company" (focus)="showCompanyDropdown = true"
                            (blur)="hideDropdown('company', $event)" (input)="onCompanyInput($event.target.value)"
                            [(ngModel)]="filterCompany">
                    </mat-form-field>

                    <div *ngIf="showCompanyDropdown">
                        <cdk-virtual-scroll-viewport *ngIf="filteredCourseCompanies.length" itemSize="40"
                            class="dropdown-viewport" (scrolledIndexChange)="onCompanyScrolled($event)">
                            <div *cdkVirtualFor="let company of filteredCourseCompanies" class="dropdown-item"
                                (mousedown)="onCompanySelected(company.company_name)">
                                {{ company.company_name }}
                            </div>
                        </cdk-virtual-scroll-viewport>
                    </div>
                </div>

                <!-- Month Filter -->
                <div>
                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Date (YYYY-MM-DD)</mat-label>

                        <!-- Show selected date -->
                        <input matInput [matDatepicker]="picker" placeholder="Choose date" [(ngModel)]="selectedMonth"
                            (dateChange)="chosenDateHandler($event.value)" readonly />

                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                </div>






                <!-- Clear Button -->
                <div style="flex: 0 0 auto;">
                    <button mat-button class="clear-btn" type="button" (click)="clearAllFilters()">Clear</button>
                </div>
            </div>
        </section>





        <form class="form-section">
            <div class="filterJoblist aligned-container">
                <div class="job-status-tabs">
                    <button type="button" class="status-tab" [class.active]="currentTab === 'ALL'"
                        (click)="onTabChange('ALL')">
                        All <span class="count-badge">{{ tabCounts.ALL || 0 }}</span>
                    </button>
                    <button type="button" class="status-tab" [class.active]="currentTab === 'DRAFT'"
                        (click)="onTabChange('DRAFT')">
                        Draft <span class="count-badge">{{ tabCounts.DRAFT || 0 }}</span>
                    </button>
                    <button type="button" class="status-tab" [class.active]="currentTab === 'PENDING'"
                        (click)="onTabChange('PENDING')">
                        Pending Approval <span class="count-badge">{{ tabCounts.PENDING || 0 }}</span>
                    </button>
                    <button type="button" class="status-tab" [class.active]="currentTab === 'ACTIVE'"
                        (click)="onTabChange('ACTIVE')">
                        Active <span class="count-badge">{{ tabCounts.ACTIVE || 0 }}</span>
                    </button>
                    <button type="button" class="status-tab" [class.active]="currentTab === 'INACTIVE'"
                        (click)="onTabChange('INACTIVE')">
                        Inactive <span class="count-badge">{{ tabCounts.INACTIVE || 0 }}</span>
                    </button>
                    <button type="button" class="status-tab" [class.active]="currentTab === 'EXPIRED'"
                        (click)="onTabChange('EXPIRED')">
                        Expired <span class="count-badge">{{ tabCounts.EXPIRED || 0 }}</span>
                    </button>
                    <!-- <button type="button" class="status-tab" [class.active]="currentTab === 'APPROVE'"
                        (click)="onTabChange('APPROVE')">
                        APPROVED <span class="count-badge">{{ tabCounts.APPROVE || 0 }}</span>
                    </button> -->
                    <button type="button" class="status-tab" [class.active]="currentTab === 'REJECTED'"
                        (click)="onTabChange('REJECTED')">
                        Rejected <span class="count-badge">{{ tabCounts.REJECTED || 0 }}</span>
                    </button>


                </div>

            </div>
        </form>

    </section>


    <div infiniteScroll [infiniteScrollDistance]="3" [infiniteScrollThrottle]="150" (scrolled)="loadMoreCourses()">


          <div *ngIf="dataLoader" class="custom-loader custom_logo_loader no-datas">
            <img src='../../../../../assets/images2/loader.gif' alt="loading" style="width: 20%;" />
        </div>

        <!---jobList Item-->
        <ng-container *ngIf="!dataLoader">
            <ng-container *ngIf="allCoursesData?.length > 0; else noData">
                <section class="master_add_sec" *ngFor="let x of allCoursesData; trackBy: trackByCourseId">
                    <mat-card class="job-card" fxLayout="column" fxLayoutGap="16px" [ngClass]="{ 'highlight-row': x.id === receivedId }">
                        <!-- Row: Avatar + Content -->
                        <div fxLayout="row" fxLayoutGap="16px" fxLayoutAlign="start center">
                          
                            <div class="presenters" *ngIf="x?.presenters?.length > 0; else noPresenters">
                                <swiper [config]="prsentersConfig" class="mySwiper">
                                    <div *ngFor="let presenter of x.presenters" class="swiper-slide presenter-card">
                                        <div class="avatar">
                                            <img *ngIf="presenter?.presented_by_image?.url" [src]="presenter.presented_by_image.url"
                                                alt="Avatar" loading="lazy" />
                                        </div>
                                        <div class="presenter-name">
                                            {{ presenter.presented_by_name }}
                                        </div>
                                    </div>
                                </swiper>
                            </div>
                            
                            <ng-template #noPresenters>
                                <div class="avatar"></div>
                            </ng-template>

                         

                            <div fxFlex class="content-box" fxLayout="column" fxLayoutAlign="start start">
                                <!-- Top Row -->
                                <div fxLayout="row" fxLayoutAlign="space-between center" class="top-row">
                                    <div class="title">
                                        <strong class="title_head">{{x.course_name}}</strong>
                                        <span class="date">• Posted on : {{x.created_at | date : 'dd-MM-yyyy'}}</span>
                                    </div>
        
                                    <!-- Status + Menu -->
                                    <!-- Status + Menu Button -->
                                    <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px" class="status-menu">
                                        <div *ngIf="x?.status" class="dynamic-status-badges" fxLayout="row" fxLayoutGap="8px">
                                            <div *ngIf="x?.status === 'DRAFT'" class="status-badge draft">DRAFT</div>
        
                                            <div *ngIf="x?.status === 'APPROVE' && x?.active_status === 'ACTIVE' && loginDetails?.type !== 'PROFESSIONAL'"
                                                class="status-badge active">
                                                ACTIVE
                                            </div>
        
                                            <div *ngIf="x?.status === 'APPROVE' && x?.active_status === 'INACTIVE'"
                                                class="status-badge active">
                                                INACTIVE
                                            </div>
        
                                            <div *ngIf="x?.status === 'PENDING'" class="status-badge pending">PENDING</div>
        
                                            <div *ngIf="x?.status === 'REJECT'" class="status-badge rejected">REJECTED</div>
        
                                            <div *ngIf="x?.status === 'EXPIRED'" class="status-badge expired">EXPIRED</div>
                                        </div>
        
                                        <!-- Menu Trigger -->
                                        <!-- Menu Trigger -->
                                        <button mat-icon-button [matMenuTriggerFor]="menu" class="menu-btn">
                                            <mat-icon>more_horiz</mat-icon>
                                        </button>
        
                                        <mat-menu #menu="matMenu" class="custom-menu">
                                            <!-- Preview -->
                                            <button mat-menu-item (click)="viewCourse(x.id)">
                                                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
                                                    <img src="assets/images2/view.svg" width="18" height="18" />
                                                    <span class="menu-label orange">Preview</span>
                                                </div>
                                            </button>
        
                                            <!-- Edit -->
                                            <button mat-menu-item *ngIf="canEdit(x.created_by_id) && !['EXPIRED'].includes(x.status)" (click)="editCourse(x)">
                                                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
                                                    <img src="assets/images2/edit.svg" width="18" height="18" />
                                                    <span class="menu-label blue">Edit</span>
                                                </div>
                                            </button>

                                            <!-- Relist -->
                                            <button mat-menu-item *ngIf="canEdit(x.created_by_id) && x.status === 'EXPIRED' " (click)="editCourse(x)">
                                                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
                                                    <mat-icon color="primary">refresh</mat-icon>
                                                    <span class="menu-label blue">Relist</span>
                                                </div>
                                            </button>
        
                                            <!-- Toggle Active/Inactive -->
                                            <button mat-menu-item *ngIf="creator(x.created_by_id) && x?.active_status === 'ACTIVE' && x.status === 'APPROVE' "
                                                (click)="updateCourseStatus('INACTIVE', x.id)">
                                                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
                                                    <img src="assets/images2/moon.svg" width="18" height="18" />
                                                    <span class="menu-label orange">Inactive</span>
                                                </div>
                                            </button>
        
                                            <button mat-menu-item
                                                *ngIf="creator(x.created_by_id) && x?.active_status === 'INACTIVE' && x.status === 'APPROVE' "
                                                (click)="updateCourseStatus('ACTIVE', x.id)">
                                                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
                                                    <img src="assets/images2/moon.svg" width="18" height="18" />
                                                    <span class="menu-label green">Active</span>
                                                </div>
                                            </button>
        
                                            <!-- Approve / Reject for Admin -->
                                            <button mat-menu-item
                                                *ngIf="isAdmin() && x?.status !== 'APPROVE' && x?.status !== 'DRAFT' &&  x?.status !== 'EXPIRED'"
                                                (click)="updateCourseApprovalStatus('APPROVE', x.id)">
                                                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
                                                   <i class="fa fa-check" style="font-size: 20px; color: green;"></i>
                                                    <span class="menu-label green">Approve</span>
                                                </div>
                                            </button>
        
                                            <button mat-menu-item
                                                *ngIf="isAdmin() && x?.status === 'PENDING' "
                                                (click)="updateCourseApprovalStatus('REJECT', x.id)">
                                                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
                                                     <mat-icon color="warn">cancel</mat-icon>
                                                    <span class="menu-label red">Reject</span>
                                                </div>
                                            </button>
        
                                            <!-- Delete now passes only id -->
                                            <button mat-menu-item *ngIf="creator(x.created_by_id) && (x.status === 'DRAFT' || x.status === 'PENDING' )"
                                                (click)="deleteCourse(x.id)">
                                                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
                                                    <img src="assets/images2/trash.svg" width="18" height="18" />
                                                    <span class="menu-label red">Delete</span>
                                                </div>
                                            </button>
                                        </mat-menu>
                                        <!-- Menu Trigger Buttons -->
                                        <!-- <ng-container
                                            *ngIf="loginDetails?.type !== 'ADMIN' && loginDetails?.type !== 'PROFESSIONAL'">
                                            <button mat-icon-button [matMenuTriggerFor]="menuUser" class="menu-btn">
                                                <mat-icon>more_horiz</mat-icon>
                                            </button>
                                            <mat-menu #menuUser="matMenu" class="custom-menu" style="overflow: hidden !important;">
                                                Preview
                                                <button mat-menu-item (click)="viewCourse(x)">
                                                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
                                                        <img src="../../../../../assets/images2/preview.svg" width="18"
                                                            height="18" />
                                                        <span class="menu-label"
                                                            style="font-size: 14px; font-weight: 600;">Preview</span>
                                                    </div>
                                                </button>
        
        
                                                <button mat-menu-item (click)="editCourse(x)">
                                                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
                                                        <img src="assets/images2/edit.svg" width="18" height="18" />
                                                        <span class="menu-label blue">Edit</span>
                                                    </div>
                                                </button>
        
        
                                                Toggle Status
                                                <button mat-menu-item *ngIf="x.active_status === 'ACTIVE' && x?.status !== 'DRAFT'"
                                                    (click)="updateCourseStatus('INACTIVE', x.id)">
                                                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
                                                        <img src="assets/images2/moon.svg" width="18" height="18" />
                                                        <span class="menu-label orange">Inactive</span>
                                                    </div>
                                                </button>
        
                                                <button mat-menu-item *ngIf="x.active_status === 'INACTIVE' && x?.status !== 'DRAFT'"
                                                    (click)="updateCourseStatus('ACTIVE', x.id)">
                                                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
                                                        <img src="assets/images2/moon.svg" width="18" height="18" />
                                                        <span class="menu-label green">Active</span>
                                                    </div>
                                                </button>
        
                                                Delete
                                                <button mat-menu-item (click)="deleteCourse(x)">
                                                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
                                                        <img src="assets/images2/trash.svg" width="18" height="18" />
                                                        <span class="menu-label red">Delete</span>
                                                    </div>
                                                </button>
                                            </mat-menu>
                                        </ng-container> -->
        
                                        <!-- ADMIN Menu -->
                                        <!-- <ng-container *ngIf="loginDetails?.type === 'ADMIN'">
                                            <button mat-icon-button [matMenuTriggerFor]="menuAdmin" class="menu-btn">
                                                <mat-icon>more_horiz</mat-icon>
                                            </button>
                                            <mat-menu #menuAdmin="matMenu" class="custom-menu" style="overflow: hidden !important;">
                                                Approve
                                                <button mat-menu-item (click)="approveCourse('APPROVE', x.id)"
                                                    *ngIf="x?.status !== 'APPROVE' && x?.status !== 'DRAFT'">
                                                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
                                                        <img src="assets/images2/tick.svg" width="18" height="18" />
                                                        <span class="menu-label green">Approve</span>
                                                    </div>
                                                </button>
        
                                                Reject
                                                <button mat-menu-item (click)="rejectCourse('REJECT', x.id)"
                                                    *ngIf="x?.status !== 'REJECT' && x?.status !== 'DRAFT'">
                                                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
                                                        <img src="assets/images2/cross.svg" width="18" height="18" />
                                                        <span class="menu-label red">Reject</span>
                                                    </div>
                                                </button>
        
                                                Toggle Status
                                                <button mat-menu-item *ngIf="x.active_status === 'ACTIVE' && x?.status !== 'DRAFT'"
                                                    (click)="updateCourseStatus('INACTIVE', x.id)">
                                                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
                                                        <img src="assets/images2/moon.svg" width="18" height="18" />
                                                        <span class="menu-label orange">Inactive</span>
                                                    </div>
                                                </button>
        
                                                <button mat-menu-item *ngIf="x.active_status === 'INACTIVE' && x?.status !== 'DRAFT'"
                                                    (click)="updateCourseStatus('ACTIVE', x.id)">
                                                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
                                                        <img src="assets/images2/moon.svg" width="18" height="18" />
                                                        <span class="menu-label green">Active</span>
                                                    </div>
                                                </button>
        
                                                <button mat-menu-item (click)="viewCourse(x)">
                                                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
                                                        <img src="../../../../../assets/images2/preview.svg" width="18" height="18" />
                                                        <span class="menu-label">Preview</span>
                                                    </div>
                                                </button>
        
                                                <button mat-menu-item (click)="editCourse(x)">
                                                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
                                                        <img src="assets/images2/edit.svg" width="18" height="18" />
                                                        <span class="menu-label blue">Edit</span>
                                                    </div>
                                                </button>
                                                Delete
                                                <button mat-menu-item (click)="deleteCourse(x)">
                                                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
                                                        <img src="assets/images2/trash.svg" width="18" height="18" />
                                                        <span class="menu-label red">Delete</span>
                                                    </div>
                                                </button>
                                            </mat-menu>
                                        </ng-container> -->
        
                                        <!-- PROFESSIONAL Menu -->
                                        <!-- <ng-container *ngIf="loginDetails?.type === 'PROFESSIONAL'">
                                            <button mat-icon-button [matMenuTriggerFor]="menuPro" class="menu-btn">
                                                <mat-icon>more_horiz</mat-icon>
                                            </button>
                                            <mat-menu #menuPro="matMenu" class="custom-menu">
                                                <button mat-menu-item (click)="viewCourse(x)">
                                                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
                                                        <img src="assets/images2/preview.png" width="18" height="18" />
                                                        <span class="menu-label">Preview</span>
                                                    </div>
                                                </button>
                                            </mat-menu>
                                        </ng-container> -->
                                    </div>
        
                                </div>


                                <!-- Chips + Applicants -->
                                <div fxLayout="row" fxLayoutAlign="space-between center" class="chip-row">
                                    <mat-chip-list class="chip-list" aria-label="Job Types">
                                        <mat-chip>
                                            {{ x.type }}
                                        </mat-chip>
                                    </mat-chip-list>
                                    <span class="applicants" [routerLink]="['/profile/course-listing/registered', x.id]">
                                        {{ x.course_registered_users_aggregate.aggregate.count }} Registered
                                    </span>
                                </div>
        
        
        
                            </div>
                        </div>
        
                        <div class="inner-divider"></div>
        
                        <!-- Footer -->
                        <div class="job-footer" fxLayout="column" fxLayoutGap="16px">
                            <div>
                                <div class="job-desc-heading">Course Description</div>
                                <div class="description">
                                    {{x.description}}
                                </div>
                            </div>
                        </div>
        
                        <div class="inner-divider"></div>
        
                        <div class="view-details" fxLayout="row" fxLayoutGap="4px" fxLayoutAlign="end center"
                            [routerLink]="['/learning/learning-hub-details', x.id]">
                            <span>View Details</span>
                            <mat-icon>chevron_right</mat-icon>
                        </div>
                    </mat-card>
                </section>
            </ng-container>
        
            <div *ngIf="loading && allCoursesData.length > 0" class="loading-more" fxLayout="row" fxLayoutAlign="center center">
                <img src="../../../../../assets/images2/loader.gif" alt="Loading more..." loading="lazy" width="80px" />
            </div>
        
            <div *ngIf="endOfData && !loading && allCoursesData.length > 0" class="text-center py-3 text-muted">
                You've reached the end — no more courses to display
            </div>
        
        </ng-container>

     <ng-template #noData>
        <div class="no-data-wrapper">
          <img src="../../../../../assets/images/icons/no_tasks.svg" alt="No records illustration" class="no-data-image" />
             <div class="no-record-text">  No
            <span *ngIf="currentTab ==='ACTIVE' ">active</span>
            <span *ngIf="currentTab ==='INACTIVE' ">inactive</span>
            <span *ngIf="currentTab ==='PENDING' ">pending</span>
            <span *ngIf="currentTab ==='REJECTED' "> rejected</span>
            <span *ngIf="currentTab ==='EXPIRED' ">expired</span>
            <span *ngIf="currentTab ==='DRAFT' ">draft</span> courses available at the moment
          </div>
        </div>
      </ng-template>

        

    </div>


</section>